import { render } from "./BackgroundVideo.vue?vue&type=template&id=e2ae83f6&scoped=true&ts=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=ts"
export * from "./BackgroundVideo.vue?vue&type=script&lang=ts"

import "./BackgroundVideo.vue?vue&type=style&index=0&id=e2ae83f6&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2ae83f6"]])

export default __exports__